import type { LucideProps } from 'lucide-react';
import * as LucideIcons from 'lucide-react';
import type { ComponentType } from 'react';
import { useMemo } from 'react';
import type { OdinIconName } from '../../components/odin-icon/odin-icon.component';

export const useLoadIcon = (iconName: OdinIconName): ComponentType<LucideProps> => {
  return useMemo(() => {
    const IconComponent = LucideIcons[iconName as keyof typeof LucideIcons] as ComponentType<LucideProps> | undefined;

    if (!IconComponent) {
      const Placeholder = () => <LucideIcons.SquareDashed size={18} />;
      Placeholder.displayName = 'BoundMissingIconPlaceholder';
      return Placeholder;
    }

    return IconComponent;
  }, [iconName]);
};
